<template>
    <div v-if="linkVerified" class="page-404-bg">
        <div class="wrapper-pages pt-2 pt-sm-5 pb-4 pb-sm-5 position-relative">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xxl-4 col-lg-5">
                        <div class="brand-logo mb-5 text-center">
                            <a href="index.html">
                                <router-link to="/login">
                                    <img :src="`${$logoDir}logo-auth.png`" alt="HAXO" height="72" class="img-fluid">
                                </router-link>
                            </a>
                        </div>

                        <div class="card">
                            <div class="card-body p-4">
                                <div class="text-center">
                                    <h1 class="text-error">{{ $t('acceptInvitation.title') }}</h1>
                                    <div class="my-auto text-white mb-3">
                                        <div class="mb-2">
                                            <div class="form-check">
                                                <input type="checkbox" v-model="confirmation" class="form-check-input" id="checkbox-cgu">
                                                {{ $t('acceptInvitation.agreement', { company }) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <form @submit.prevent="handleSubmit" class="pb-4">
                                    <div class="d-grid mb-0 text-center">
                                        <button class="btn btn-info" type="submit" :disabled="!confirmation"><i class="mdi mdi-check"></i> {{ $t('acceptInvitation.accept') }}</button>
                                    </div>
                                    <div v-if="errorMessage" class="mt-2 text-white">
                                        {{ errorMessage }}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer class="footer footer-alt text-white">
            {{ year }} {{ $t('common.copyright') }}
        </footer>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/stores/userStore';
import { useI18n } from 'vue-i18n';

export default {
    name: 'AcceptInvitation',
    setup() {
        const router = useRouter();
        const route = useRoute();
        const userStore = useUserStore();
        const { t } = useI18n();
        const year = new Date().getFullYear();
        const uuid = route.query.uuid;
        const errorMessage = ref(null);
        const linkVerified = ref(false);
        const company = ref(null);
        const confirmation = ref(false);

        if(uuid === undefined) {
            router.push({ path: "/404"});
        }

        onMounted(async () => {
            try {
                const response = await userStore.checkUUID(uuid, 'installer_invite');
                company.value = response.company_name;
                linkVerified.value = true;
            } catch (error) {
                router.push({ path: "/result", query: { success: false, title: t('common.failure'), message: error }});
            }
        });

        async function handleSubmit() {
            try {
                await userStore.acceptInvitation(uuid);
                router.push({ path: "/result", query: { success: true, title: t('common.done'), message: t('acceptInvitation.successMessage', { company: company.value }) }});
            } catch (error) {
                errorMessage.value = error;
            }
        }

        return {
            year,
            handleSubmit,
            errorMessage,
            linkVerified,
            company,
            confirmation,
        }
    }
}
</script>

<style scoped>
.page-404-bg {
    background: rgb(45, 64, 140);
    background: linear-gradient(164deg, rgb(32, 123, 194) 0%, rgb(45, 64, 140) 50%, rgb(114, 44, 132) 100%);
}

.page-404-bg .wrapper-pages {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    min-height: 100vh;
}

.page-404-bg .card {
    background: rgba(255, 255, 255, 0.11);
    border-radius: 16px;
    -webkit-box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
}

.page-404-bg .text-error {
    color: #fff !important;
    text-shadow: rgba(255, 255, 255, 0.3) 5px 1px, rgba(255, 255, 255, 0.2) 10px 3px;
    font-size: 52px;
}

</style>
